export type markupType =
  | 'Recipe'
  | 'Product'
  | 'FAQPage'
  | 'Organization'
  | 'CollectionPage'
  | 'SearchResultsPage'
  | 'LocalBusiness'
  | 'SearchAction'
export type schemaType =
  | 'WebPage'
  | 'ItemPage'
  | 'AboutPage'
  | 'CollectionPage'
  | 'FAQPage'
  | 'SearchResultsPage'
  | 'LocalBusiness'
  | 'WebSite'
export type objectType =
  | Product
  | Product[]
  | FAQ[]
  | FAQ
  | Recipe
  | LocalBusiness

export const markupToSchema: Record<markupType, schemaType> = {
  Recipe: 'ItemPage',
  Product: 'ItemPage',
  FAQPage: 'FAQPage',
  Organization: 'AboutPage',
  CollectionPage: 'CollectionPage',
  SearchResultsPage: 'SearchResultsPage',
  LocalBusiness: 'LocalBusiness',
  SearchAction: 'WebSite'
}

export type JsonLdProps = {
  type: markupType
  object?: objectType
}

export interface Product {
  name: string
  sku: string
  description: string
  url: string
  image: string
  price: number
  promotionalPrice: number
  currency: string
  orderable: boolean
}

export type FAQ = {
  question: string
  answer: string
}

export type Recipe = {
  name: string
  totalTime: string
  recipeYield: string
  url: string
  image?: string
  recipeIngredient: string[]
  recipeInstructions: {
    '@type': 'HowToStep'
    text: string
  }[]
}

export type LocalBusiness = {
  name: string
  address: {
    streetAddress: string
    addressLocality: string
    addressRegion: string
    postalCode: string
    addressCountry: string
  }
  geo: {
    latitude: number
    longitude: number
  }
  url: string
  image?: string[]
  tel: string
  openingHours?: {
    dayOfWeek: string[]
    opens: string
    closes: string
  }[]
}
